var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CtkDateTimePicker',_vm._g(_vm._b({staticClass:"evercam-field caption",attrs:{"value":_vm.currentValue,"label":`Please select the ${_vm.label}`,"disabled":_vm.disabled,"format":"YYYY-MM-DDTHH:mm:ss.SSS[Z]"}},'CtkDateTimePicker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }